import React, { useState, useMemo, FC } from 'react';
import classNames from 'classnames';

import { AccordionData } from '../types';
import Accordion from '..';

import styles from './index.module.scss';

export type AccordionListProps = {
  elementId: string;
  data: AccordionData[];
  containerClassName?: string;
  itemClassName?: string;
  itemTitleClassName?: string;
  itemDescriptionClassName?: string;
  itemDescriptionHiddenClassName?: string;
  openedIndex?: number;
  openIconPlacement?: 'left' | 'right';
};

const AccordionList: FC<AccordionListProps> = ({
  elementId,
  data,
  containerClassName,
  itemClassName,
  itemTitleClassName,
  itemDescriptionClassName,
  itemDescriptionHiddenClassName,
  openedIndex = 0,
  openIconPlacement,
}) => {
  const [activeIndex, setActiveIndex] = useState<number>(openedIndex);

  const accordionItems = useMemo(
    () =>
      data.map((item, index) => (
        <Accordion
          key={item.id}
          elementId={`accordion_${item.title}_${index}`}
          className={itemClassName}
          id={index}
          title={item.title}
          description={item.description}
          titleClassName={itemTitleClassName}
          descriptionClassName={itemDescriptionClassName}
          descriptionHiddenClassName={itemDescriptionHiddenClassName}
          isOpen={activeIndex === index}
          openIconPlacement={openIconPlacement}
          onClick={setActiveIndex}
        />
      )),
    [data, activeIndex]
  );

  return (
    <div
      id={elementId}
      data-testid={elementId}
      className={classNames(styles.AccordionListContainer, containerClassName)}>
      {accordionItems}
    </div>
  );
};

export default AccordionList;
